/**
 * Error codes login flow answers with, which the sign-in form turns into copy.
 */
export const LOGIN_UNCONFIRMED = "unconfirmedUser"
export const LOGIN_LEGACY_UNCONFIRMED = "legacyUnconfirmedUser"
export const LOGIN_DELETED_ACCOUNT = "deletedAccount"
